import GoogleOauth2Provider from './GoogleOauth2Provider';

export default GoogleOauth2Provider;
